// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line no-unused-vars
import { FxPageContainer } from 'axp-fx-common';
// eslint-disable-next-line no-unused-vars
import ManageFxAccountDirectory from './ManageFxAccountDirectory';
// eslint-disable-next-line no-unused-vars
import UpdatePassword from '../../Common/UpdatePassword/UpdatePassword';
import {
  fxAccountBreadcrumbs,
  updateFxAccountPasswordBreadcrumb,
} from '../../../constants/breadcrumbs';
import actionType from '../../../constants/actionType';
import labels from '../../../constants/labels';

const ManageFxAccount = () => {
  const [stepNo, setStepNo] = useState(1);
  const [selectedFxAccount, setSelectedFxAccount] = useState({});

  return (
    <FxPageContainer>
      {stepNo === 1 && (
        <ManageFxAccountDirectory
          setStepNo={setStepNo}
          selectedFxAccount={selectedFxAccount}
          setSelectedFxAccount={setSelectedFxAccount}
        />
      )}

      {stepNo === 2 && (
        <UpdatePassword
          selectedFxAccount={{
            fxAccountId: selectedFxAccount?.fxAccountId,
            fxAccountName: selectedFxAccount?.fxAccountName,
            password: '',
            confirmPassword: '',
            environment: selectedFxAccount?.environment,
          }}
          setStepNo={setStepNo}
          baseBreadcrumb={fxAccountBreadcrumbs}
          finalBreadcrumb={updateFxAccountPasswordBreadcrumb}
          pageHeaderTxt="Update Password"
          actionButtonLabelTxt="Update Password"
          performAnotherActionButtonTxt={`Go to ${labels.FX_ACCOUNT}`}
          action={actionType.UPDATE_FX_ACCOUNT_PASSSWORD.name}
        />
      )}
    </FxPageContainer>
  );
};

export default ManageFxAccount;

ManageFxAccount.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({}),
  }),
};
